import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useMutation} from '@tanstack/react-query';
import {AppMedError} from '../../../error/AppMedError.ts';
import {TasksApi} from '../../../apis/TasksApi/TasksApi.ts';

export function usePutTask() {
    return useMutation<number, AppMedError, { taskId: string; variables: { completionDate: Date; } }>(
        {
            mutationKey: [QueryKeys.tasks],
            mutationFn: async ({taskId, variables}) => {
                return await TasksApi.putTask(taskId, variables);
            },
        }
    );
}